import styled from 'styled-components/native';
import style from '../../styles';

export const Container = styled.View`
  background: ${style.colors.white};
  flex: 1;
`;
